// extracted by mini-css-extract-plugin
export default {"rules":"zA4BHm65","nowrap":"kvf5EqhC"};